module.exports = __webpack_public_path__ + "img/category_29.91fed782.png";